var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useGetClientDetailsQuery, useGetPermissions, } from "../store/api/core";
import { permissionKeys } from "./permissionTypes";
var isPermissioned = function (permissions, resourceName) {
    return Array.isArray(permissions) &&
        permissions.some(function (permission) { return (permission === null || permission === void 0 ? void 0 : permission.resourceName) === resourceName; });
};
export var usePermissions = function () {
    var _a, _b, _c, _d;
    var clientDetails = useGetClientDetailsQuery({});
    var permissions = useGetPermissions();
    var hasTalentReviewPermissionExist = isPermissioned(permissions, "ORG_DASHBOARD_UI/TALENT_REVIEW");
    var is_nine_box_enabled = ((_b = (_a = clientDetails.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.nine_box_enabled) || false;
    var showDiversitySpecific = ((_d = (_c = clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.hide_gender_and_ethnicity) == false;
    var resourceNames = new Set((permissions === null || permissions === void 0 ? void 0 : permissions.map(function (p) { return p.resourceName; })) || []);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var returned = __assign(__assign({ nineBox: hasTalentReviewPermissionExist && is_nine_box_enabled }, Object.entries(permissionKeys).reduce(function (current, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        return (__assign(__assign(__assign({}, current), Array.from(resourceNames).reduce(function (acc, resourceName) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[resourceName] = true, _a)));
        }, {})), (_b = {}, _b[key] = isPermissioned(permissions, value), _b)));
    }, {})), { showDiversitySpecific: showDiversitySpecific, conditions: [clientDetails] });
    return returned;
};
